export default __webpack_public_path__ + "static/media/error404.fdeb0fe7.gif";